import { mapGetters } from 'vuex'
import province_city_area from '@form-create/data/dist/province_city_area.js'

export default {
    components: {},
    data() {
        return {
            upload_url: process.env.VUE_APP_BASE_API + '/api/file'
        }
    },
    computed: {
        ...mapGetters(['token', 'tougaoInfo'])
    },
    created() {},
    methods: {
        getValidatorCallBackNew(field) {
            let validate = {
                reg: '',
                message: ''
            }
            switch (field) {
                case 'mobile':
                    validate = {
                        reg: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                        message: this.$t('tougao.correct_mobile')
                    }
                    break

                case 'email':
                    validate = {
                        reg: /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/,
                        message: this.$t('tougao.correct_email')
                    }
                    break

                case 'card':
                    validate = {
                        reg: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
                        message: this.$t('tougao.corrent_card')
                    }
                    break

                default:
                    break
            }
            return validate
        },

        resetCascaderOptions(setting) {
            setting.forEach((item) => {
                if (item.type === 'cascader') {
                    item.props.options = []
                }
            })
            return setting
        },

        addCascaderOptions(setting) {
            setting.forEach((item) => {
                if (item.type === 'cascader') {
                    item.props.options = province_city_area
                }
            })
            return setting
        },

        resetFormRules(rules, fApi) {
            // 格式化 人员信息、作品信息表单规则(渲染form表单需要)
            // console.log('rules-------', rules)
            const newRules = rules.map((item) => {
                if (item.type === 'upload') {
                    item.field === 'thumb_id' ? (item.props.limit = 1) : ''
                    item.props.action = this.upload_url
                    item.props.headers.Authorization = this.token
                    item.props.onSuccess = (res) => {
                        const values = this[fApi].getValue(item.field) || []
                        values.push(res.data.url)
                        this[fApi].setValue(item.field, values)
                    }
                }

                if (item.type === 'cascader') {
                    item.props.options = province_city_area
                }

                const valid = this.getValidatorCallBackNew(item.valid_field)
                valid.reg
                    ? item.validate.push({
                          type: 'string',
                          required: true,
                          pattern: valid.reg,
                          message: valid.message,
                          trigger: 'blur'
                      })
                    : item.validate

                // return item
                return {
                    field: item.field,
                    props: item.props,
                    options: item.options ? item.options : [],
                    title: item.title,
                    type: item.type,
                    valid_field: item.valid_field,
                    validate: item.validate,
                    value: item.value,
                    tableShow: item.tableShow
                }
            })
            console.log('newRules', newRules)
            return newRules
        },

        formatFileUrlToObject(item, key = 'file_ids_urls') {
            // 格式化 后台的{id:url} 为[{id：id, url:url}]
            const ids_urls = []
            const obj = item[key]
            const isArray = obj instanceof Array // 解决：后端返回的数据有时候{}有时候[]

            if (!isArray && item[key] && Object.keys(obj).length > 0) {
                Object.keys(obj).map((i_item) => {
                    ids_urls.push({
                        id: i_item,
                        url: obj[i_item]
                    })
                })
                item[key] = ids_urls
            }
            return item
        }
    }
}
